define 'controller/SliderController', ['jquery', 'custom/media-query', 'lib/owl.carousel'], ($, mq) ->
  class SliderController

    constructor: (@$el) ->
      $slider = @$el.find('[data-controller-element=owl-slider-carousel]')
      $slider.addClass('owl-carousel')
      $slider.owlCarousel({
        loop: false,
        items: 2,
        dots: false,
        nav: true,
        slideBy: 2,
        margin: 10,
        responsive: {
          360:{
            items: 3,
            slideBy: 3
          }
          575:{
            items: 4,
            slideBy: 4
          }
          991:{
            items: 6
            slideBy: 6
          }
          1800:{
            items: 6,
            slideBy: 6
          }
        },
        onInitialized: ->
          $slider.find("button").removeAttr("role")
          $slider.find("button.owl-prev").attr("aria-label", "Articles précédents")
          $slider.find("button.owl-next").attr("aria-label", "Articles suivants")
      })

    destroy: ->
      @$el.off()
